import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import DashboardSectionForm from '../containers/DashboardSectionFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class DashboardSectionAddScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `DashboardSectionAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('dashboard_sections_route_add')} />
            <DashboardSectionForm />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default DashboardSectionAddScreen;

Logger.log('silly', `DashboardSectionAddScreen loaded.`);
